module.exports = __webpack_public_path__ + "img/95.ef4b6914.png";